import styled, { css } from 'styled-components';
import { FlexibleDiv } from '../../styled/common';
import Logo from '../../public/static/images/brown-logo.svg';

export const LogoFlexibleBlock = styled(FlexibleDiv)`
  align-items: center;
  gap: 20px;
  position: relative;
  margin-right: 25px;
`;

export const SwitcherBlock = styled.div`
  position: absolute;
  z-index: 1;
  width: 48px;
  height: 70px;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0 15px;
  margin-left: -15px;
`;
export const shouldForwardProp = prop => !['isShowBurgerIcon'].includes(prop);
export const StyledLogoIcon = styled(Logo).withConfig({ shouldForwardProp })`
  cursor: pointer;
  margin-left: ${({ isShowBurgerIcon }) => (isShowBurgerIcon ? '38px' : '0')};
  path {
    fill: ${({ theme }) => theme.colors.systemColors.brand};
  }
`;

export const Switcher = styled.div`
  display: flex;
  width: 18px;
  height: 14px;
  margin-top: 1px;

  ${({ active }) =>
    active &&
    css`
      margin-top: 0;
    `}
`;

export const SwitcherIcon = styled.span`
  position: relative;
  width: 18px;
  height: 2px;
  border-radius: 14px;
  margin: auto 0;
  background: ${({ theme }) => theme.colors.systemColors.brand};
  transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  transition-property: transform;

  &:before,
  &:after {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    width: 18px;
    height: 2px;
    background: ${({ theme }) => theme.colors.systemColors.brand};
    border-radius: 14px;
  }

  &:before {
    bottom: calc(100% + 4px);
    transition:
      bottom 0.1s ease-in 0.25s,
      opacity 0.1s ease-in;
  }

  &:after {
    top: calc(100% + 4px);
    transition:
      top 0.1s ease-in 0.25s,
      transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  ${({ active }) =>
    active &&
    css`
      border-radius: 0;
      border: none;
      transition-delay: 0.12s;
      transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
      transform: rotate(225deg);

      &:before {
        bottom: 0;
        opacity: 0;
        transition:
          bottom 0.1s ease-out,
          opacity 0.1s ease-out 0.12s;
      }

      &:after {
        top: 0;
        border-radius: 0;
        border: none;
        transition:
          top 0.1s ease-out,
          transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;
        transform: rotate(-90deg);
      }
    `}
`;
